import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'app/components/misc/ErrorPage';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import TermsContent from 'app/pageContents/TermsContent';
import prismicApi from 'app/api/prismicApi';
import { PAGE_TYPE } from 'app/constants/app';
import { configureStaticPageHead } from 'app/utils/configurePageHead';
import get from 'lodash/get';
import { RichText } from 'prismic-reactjs';

const propTypes = {
  doc: PropTypes.object,
};

const Terms = ({ doc }) => {
  if (!doc) return <ErrorPage />;

  if (doc) {
    return (
      <Page withBackground>
        <PageHead
          {...configureStaticPageHead(
            PAGE_TYPE.TERMS,
            RichText.asText(doc.version),
          )}
        />
        <TermsContent doc={doc} />
      </Page>
    );
  }
};

Terms.getInitialProps = async ({ res }) => {
  const response = await prismicApi('document.type', 'terms');
  const doc = get(response, 'results[0].data');
  if (res && !doc) res.statusCode = 404;
  return { doc };
};

Terms.propTypes = propTypes;

export default Terms;
